// Exported constants for order enums
export const ORDER_STATUS_OPTIONS = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED', 'IMMEDIATE'];
export const ORDER_SIZE_OPTIONS = ['sizeS', 'sizeM', 'sizeL'];
